import React, { Component, useState } from "react"
import DialogTitle from "@material-ui/core/DialogTitle/DialogTitle"
import DialogContent from "@material-ui/core/DialogContent/DialogContent"
import DialogActions from "@material-ui/core/DialogActions/DialogActions"
import Button from "@material-ui/core/Button/Button"
import Dialog from "@material-ui/core/Dialog/Dialog"
import SearchOutlined from "@material-ui/icons/SearchOutlined"
import { bindActionCreators } from "redux"
import { connect } from "react-redux"
import { withSnackbar } from "notistack"
import withScroll from "../../../../../../../hocs/withScroll/withScroll"
import InputAdornment from "@material-ui/core/InputAdornment/InputAdornment"
import TextField from "@material-ui/core/TextField/TextField"
import getErrorText from "../../../../../../../library/constants/errorTypes"
import Loader from "../../../../../../../components/ui/loader/loader"
import { withStyles } from "@material-ui/core"
import { generatePath, Link } from "react-router-dom"
import * as routes from "../../../../../../../library/constants/routes"
import logoDefault from "../../../../../../../assets/img/product.svg"
import StarRating from "../../../../../../../components/ui/starRating"
import { getObjectById } from "../../../../../../../library/utils/arrays"
import { productContentTypes } from "../../../../../../../library/constants/productDictionary"
import DropdownControl from "../../../../../../../components/ui/dropdowns/dropdownControl/dropdownControl"
import MenuList from "@material-ui/core/MenuList/MenuList"
import { colors } from "../../../../../../../library/constants/styles/colors"
import MenuItem from "@material-ui/core/MenuItem/MenuItem"
import {
  addProductToStep,
  deleteProductFromStep,
  searchStepProducts,
  searchStepProductsClear,
} from "../../../../../../../library/store/actions/creators/knowmixCreators"
import styled from "@emotion/styled"
import {
  clearProductsSearch,
  searchProducts,
} from "../../../../../../../library/store/actions/creators/productsCreators"

const CustomDialog = withStyles((theme) => ({
  paper: {
    [theme.breakpoints.up("sm")]: {
      minWidth: "752px",
    },
  },
}))(Dialog)

const CustomDialogContent = withStyles({
    root: {
        padding: "16px 0 16px 24px",
        overflow: "hidden",
    },
})(DialogContent);

const CustomMenuItem = withStyles({
    root: {
        color: colors.primary,
    },
})(MenuItem);

const ListContainer = styled.div`
padding-right: 24px;
max-height: 620px;
overflow-y: auto;

.product-tile {
width: 215px;

@supports (display: grid) { 
width: 224px;
}
}
`;

class StepProductsDialog extends Component {
    state = {
        list: [],
        name: "",
        canAdd: this.props.relatedProducts.length < 10,
        initialRender: true,
        dataReceived: false,
    };

    async componentDidMount() {
        await this.getList();
        this.props.setScrollContainer(this.scrollComponent);
    }

    async componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.relatedProducts !== prevProps.relatedProducts) {
            this.setState({canAdd: this.props.relatedProducts.length < 10});
        }
    }

    componentWillUnmount() {
        this.props.clearProductsSearch();
    }

    getList = async (offset = 0, limit = 15) => {
        const {name} = this.state;

        this.setState({dataReceived: false});

        try {
            await this.props.searchProducts({name: name || undefined, offset, limit});
            this.setState({
                list: this.props.products.search,
                initialRender: false,
                dataReceived: true,
            });
        } catch ({error}) {
            this.props.enqueueSnackbar(getErrorText(error.code), {variant: "error"});
        }
    };

    handleChange = event => {
        this.setState({name: event.target.value});
    };

    processSearch = event => {
        event.preventDefault();
        this.props.clearProductsSearch();
        this.getList();
    };

    addProduct = async (product) => {
        try {
            // if (this.props.stepId) {
            //     await this.props.addProductToStep({
            //         knowmix_step_id: this.props.stepId,
            //         product_id: product.id
            //     });
            // }
            this.props.addProduct(product);
        } catch ({error}) {
            this.props.enqueueSnackbar(getErrorText(error.code), {variant: "error"});
        }
    };

    deleteProduct = async (product_id) => {
        try {
            // if (this.props.stepId) {
            //     await this.props.deleteProductFromStep({
            //         knowmix_step_id: this.props.stepId,
            //         product_id
            //     });
            // }
            this.props.deleteProduct(product_id);
        } catch ({error}) {
            this.props.enqueueSnackbar(getErrorText(error.code), {variant: "error"});
        }
    };

    onScroll = async () => {
        if (!this.state.dataReceived || this.props.knowmix.productsSearchComplete) return;
        await this.getList(this.state.list.length);
    };

    render() {
        const {list, name, canAdd, dataReceived, initialRender} = this.state;

        return (
            <CustomDialog
                open={this.props.open}
                onClose={this.props.handleClose}
                onExit={this.props.onExit ? this.props.onExit : null}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                scroll='paper'
            >
                <DialogTitle id="alert-dialog-title">
                    <p className="mb10">Products</p>
                    <form className="full-width font-weight-400 font-14" onSubmit={this.processSearch}>
                        <TextField
                            className="search-header__input full-width"
                            placeholder="Start typing product name"
                            margin="none"
                            autoComplete="off"
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <SearchOutlined style={{color: "#9b9a9b"}}/>
                                    </InputAdornment>
                                ),
                            }}
                            value={name}
                            onChange={this.handleChange}
                        />
                    </form>
                </DialogTitle>
                <CustomDialogContent>
                    {!!list.length ? (
                        <ListContainer id="products-list" ref={ref => this.scrollComponent = ref}>
                            <div className="products-list">
                                {list.map(item => (
                                    <ProductsListItem
                                        product={item}
                                        addProduct={this.addProduct}
                                        deleteProduct={this.deleteProduct}
                                        relatedProducts={this.props.relatedProducts}
                                        canAdd={canAdd}
                                        key={item.id}
                                    />
                                ))}
                            </div>
                        </ListContainer>
                    ) : (
                        !initialRender && <p className="color-black-54 text-center">Result not found</p>
                    )}
                    {!dataReceived && <Loader/>}
                </CustomDialogContent>
                <DialogActions>
                    <Button onClick={this.props.handleClose} color="primary">
                        Close
                    </Button>
                </DialogActions>
            </CustomDialog>
        );
    }
}

const ProductsListItem = ({product, ...rest}) => {
    const [isAdded, setIsAdded] = useState(rest.relatedProducts.includes(product.id));

    const addProduct = async () => {
        await rest.addProduct(product);
        setIsAdded(true);
    };

    const deleteProduct = async () => {
        await rest.deleteProduct(product.id);
        setIsAdded(false);
    };


    const composeContentType = () => {
        return getObjectById(productContentTypes, product.content_type);
    };

    const creator = product.creator_user ? {
        name: `${product.creator_user.first_name} ${product.creator_user.last_name}`,
        url: generatePath(routes.USER, {userId: product.creator_user.id}),
    } : {
        name: product.creator_group.name,
        url: generatePath(routes.GROUP, {groupId: product.creator_group.id}),
    };

    return (
        <div className="product-tile">
            <Link to={generatePath(routes.PRODUCT, {productId: product.id})} className="product-tile__logo">
                <img src={product.image || logoDefault} alt="Product image"/>
            </Link>
            <Link to={generatePath(routes.PRODUCT, {productId: product.id})}
                  className="product-tile__name link">{product.name}</Link>
            <table className="product-tile__info">
                <tbody>
                <tr>
                    <td className={`product-tile__info-label ${composeContentType() ? "pb4" : ""}`}>
                        <span>Creator:</span>
                    </td>
                    <td className={`product-tile__info-value ${composeContentType() ? "pb4" : ""}`}>
                        <span>
                            <Link to={creator.url} className="link font-weight-500">{creator.name}</Link>
                        </span>
                    </td>
                </tr>
                <tr>
                    <td className="product-tile__info-label">
                        <span>
                            {composeContentType() ? "Content type:" : ""}
                            {!composeContentType() && <span style={{height: "20px"}}></span>}
                        </span>
                    </td>
                    <td className="product-tile__info-value">
                        <span>
                            {composeContentType() ? composeContentType().name : ""}
                        </span>
                    </td>
                </tr>
                </tbody>
            </table>
            <StarRating rating={product.rating}/>
            <div className="h-divider h-divider--vertical-margin"></div>
            {isAdded ? (
                <div className="f jcc">
                    <DropdownControl buttonLabel="Added to step">
                        <MenuList>
                            <CustomMenuItem onClick={deleteProduct}>
                                Remove from step
                            </CustomMenuItem>
                        </MenuList>
                    </DropdownControl>
                </div>
            ) : (
                <Button variant="contained" color="primary" fullWidth onClick={addProduct} disabled={!rest.canAdd}>Add
                    to step</Button>
            )}
        </div>
    );
};

const mapStateToProps = ({auth, knowmix, products}) => ({auth, knowmix, products});
const mapDispatchToProps = dispatch => bindActionCreators({
    searchStepProducts,
    addProductToStep,
    deleteProductFromStep,
    searchStepProductsClear,
    searchProducts,
    clearProductsSearch,
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(withSnackbar(withScroll(StepProductsDialog)));
